import { debounce } from "@/utils/helpers"

const closeFunc = debounce(state => {
  state.showMessagePopup = false
}, 10)

export default {
  namespaced: true,
  state: {
    showMessagePopup: false,
    message: ""
  },
  getters: {
    showMessagePopup: state => state.showMessagePopup,
    message: state => state.message
  },
  mutations: {
    showMessagePopup(state, message) {
      state.message = message
      state.showMessagePopup = true
    },
    closeMessagePopup(state) {
      closeFunc(state)
    }
  }
}
